<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/QCReport/QCGroupByAgent'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
          <div class="kt-portlet__head-toolbar" v-if="reAverageScore !== null">
            <span style="background-color: #A6C9EC; padding: 6px 16px; border-radius: 4px 0 0 4px; font-weight: bold; border-right: 1px solid #8BB8E0;">
              ค่าเฉลี่ยคะแนน
            </span>
            <span style="background-color: #A6C9EC; padding: 6px 16px; border-radius: 0 4px 4px 0; font-weight: bold;">
              {{ reAverageScore }}
            </span>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่เริ่มต้น:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reStartDate"
                      name="reStartDate"
                      ref="reStartDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">วันที่สิ้นสุด:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reEndDate"
                      name="reEndDate"
                      ref="reEndDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ชื่อเจ้าหน้าที่:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reUserIds'"
                    :name="'reUserIds'"
                    :select2-options="reUserIdsOptions"
                    multiple
                    v-model="reUserIds"
                  ></select2> -->
                  <!-- <treeselect
                    v-model="reUserIds"
                    :async="true"
                    :multiple="true"
                    :cacheOptions="false"
                    :defaultOptions="true"
                    :load-options="LoadreUserIdsOptions"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                  /> -->
                  <treeselect
                    v-model="reUserIds"
                    :multiple="true"
                    :async="true"
                    :cacheOptions="false"
                    :load-options="LoadreUserIdsOptions"
                    v-on:open="reLoadreUserIdsOptions"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    ref="reUserIds"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>คะแนน QC:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reScores'"
                    :name="'reScores'"
                    :select2-options="reScoresOptions"
                    multiple
                    v-model="reScores"
                  ></select2> -->
                  <treeselect
                    v-model="reScores"
                    :multiple="true"
                    :options="reScoresOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เขตการขาย:</label>
                  <treeselect
                    v-model="reDepartments"
                    :multiple="true"
                    :options="reDepartmentsOptions"
                    :beforeClearAll="DepartmentClear"
                    :clear-on-select="true"
                    v-on:select="DepartmentSelect"
                    v-on:deselect="DepartmentDeselect"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <treeselect
                    v-model="reAgentCodes"
                    :multiple="true"
                    :options="reAgentCodesOptions"
                    :clear-on-select="true"
                    v-on:select="AgentSelect"
                    v-on:deselect="AgentDeselect"
                    :beforeClearAll="AgentClear"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ตัวแทนจำหน่ายย่อย:</label>
                  <treeselect
                    v-model="reSubAgentCodes"
                    :multiple="true"
                    :options="reSubAgentCodesOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportQIGroupByAgent"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="QIGroupByAgentTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="10">
                      ข้อมูล ณ วันที่ {{ reAaDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">ตัวแทนจำหน่าย</th>
                    <th class="all text-center">ตัวแทนจำหน่ายย่อย</th>
                    <th class="all text-center">วันที่</th>
                    <th class="all text-center">ชื่อเจ้าหน้าที่</th>
                    <th class="all text-center">เขตขาย</th>
                    <th class="all text-center">ประเภทร้านค้า<br/>(ตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย)</th>
                    <th class="all text-center">ชื่อร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า 2</th>
                    <th class="all text-center">คะแนน QC</th>
                  </tr>
                </thead>
                <!-- <tfoot v-show="isShowFooter">
                    <tr>
                        <th class="text-right" colspan="6">จำนวนรวม</th>
                        <th class="text-center">{{TotalAmount}}</th> 
                        <th class="text-center" colspan="5"></th> 
                    </tr>
                </tfoot> -->
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

const simulateAsyncOperation = (fn) => {
  setTimeout(fn, 2000);
};

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      reAaDateReq: null,
      reAverageScore: null,
      reStartDate: null,
      reEndDate: null,
      reIsInitial: true,
      reDepartments: [],
      reAgentCodes: [],
      reSubAgentCodes: [],
      reUserIds: [],
      reScores: [],
      reDepartmentsOptions: [],
      // reDepartmentsOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเขตการขาย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchDepartment",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAgentCodesOptions: [],
      allAgentCodesOptions: [],
      reSubAgentCodesOptions: [],
      allSubAgentCodesOptions: [],
      SalerAreaId: [],
      // reAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_QI",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลตัวแทนจำหน่าย";
      //     },
      //   },
      // },
      reScoresOptions: [],
      // reScoresOptions: {
      //   placeholder: "กรุณาเลือกคะแนน QC",
      //   allowClear: false,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/Variables/Options",
      //     data: function(params) {
      //       var query = {
      //         search: "QI_SCORE",
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reUserIdsOptions: [],
      reUserIdsOptionsData: [],
      // reUserIdsOptions: {
      //   placeholder: "กรุณาเลือกเจ้าหน้าที่",
      //   allowClear: false,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/Users/Select2UserQI",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.reStartDate = null;
      self.reEndDate = null;
      self.reDepartments = [];
      self.SalerAreaId = [];
      self.reAgentCodes = [];
      self.reSubAgentCodes = [];
      self.reUserIds = [];
      self.reScores = [];
      self.reUserIdsOptions = [];
      self.reAverageScore = null;

      $("#reStartDate")
        .val("")
        .trigger("change");

      $("#reEndDate")
        .val("")
        .trigger("change");

      $("#reDepartments")
        .val("")
        .trigger("change");

      $("#reAgentCodes")
        .val("")
        .trigger("change");

      $("#reUserIds")
        .val("")
        .trigger("change");

      $("#reScores")
        .val("")
        .trigger("change");

      self.LoadreAgentCodesOptions();
      self.LoadreSubAgentCodesOptions();

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      let self = this;

      e.preventDefault();
      var table = $("#QIGroupByAgentTable").DataTable();
      table.draw();
    },
    exportQIGroupByAgent: function(e) {
      e.preventDefault();
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportQIGroupByAgent",
        responseType: "arraybuffer",
        data: {
          StartDate:
            self.reStartDate != null
              ? self.reStartDate.format("DD/MM/YYYY")
              : self.reStartDate,
          EndDate:
            self.reEndDate != null
              ? self.reEndDate.format("DD/MM/YYYY")
              : self.reEndDate,
          Departments: self.reDepartments,
          AgentCodes: self.reAgentCodes,
          UserIds: self.reUserIds,
          Scores: self.reScores,
          SubAgentCodes: self.reSubAgentCodes,
          IsInitial: self.reIsInitial,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    LoadreDepartmentsOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Report/Select2QISalesArea", {
          page: 1,
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reDepartmentsOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreAgentCodesOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Report/Select2QIAgent", {
          AgentCodes: [],
          SalesAreaId: [],
          page: 1,
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            var newOptions = [];
            data.forEach((element) => {
              newOptions.push({
                id: element.id,
                label: element.text,
                salerAreaId: element.salesAreaId,
              });
            });
            self.reAgentCodesOptions = newOptions;
            self.allAgentCodesOptions = newOptions;
          }
        })
        .catch(function(error) {});
    },
    LoadreScoresOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Options", {
          params: {
            search: "QI_SCORE",
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reScoresOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreUserIdsOptions({ action, searchQuery, callback }) {
      var self = this;
      if (action == "ASYNC_SEARCH") {
        simulateAsyncOperation(() => {
          axios({
            method: "post",
            url: "/Api/Users/Select2QIGroupByAgent",
            data: {
              page: 1,
              search: searchQuery,
              SalesAreaIds : self.reDepartments,
              AgentCodes : self.reAgentCodes,
              all: true,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reUserIdsOptions = [];
              data.forEach((element) => {
                self.reUserIdsOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
              callback(null, self.reUserIdsOptions)
            }
          }).catch(function(error) {});
        })
      }

      
    },
    reLoadreUserIdsOptions: function(){
      this.$refs.reUserIds.trigger.searchQuery = null;
    },
    DepartmentSelect: function(e) {
      var self = this;
      this.SalerAreaId.push({ id: e.id });
      this.reAgentCodesOptions = [];
      this.SalerAreaId.forEach((value) => {
        this.allAgentCodesOptions.forEach((element) => {
          if (element.salerAreaId == value.id) {
            this.reAgentCodesOptions.push({
              id: element.id,
              label: element.label,
              salerAreaId: element.salerAreaId,
            });
          }
        });
      });
      this.$nextTick(function() {
        self.LoadreSubAgentCodesOptions();
      });
    },
    DepartmentDeselect: function(e) {
      var self = this;
      this.SalerAreaId = this.SalerAreaId.filter(function(value) {
        return value.id !== e.id;
      });
      if (this.SalerAreaId.length == 0) {
        this.reAgentCodesOptions = this.allAgentCodesOptions;
      } else {
        this.reAgentCodesOptions = [];
        this.SalerAreaId.forEach((value) => {
          this.allAgentCodesOptions.forEach((element) => {
            if (element.salerAreaId == value.id) {
              this.reAgentCodesOptions.push({
                id: element.id,
                label: element.label,
                salerAreaId: element.salerAreaId,
              });
            }
          });
        });
      }
      this.$nextTick(function() {
        self.LoadreSubAgentCodesOptions();
      });
    },
    DepartmentClear: function(e) {
      var self = this;
      this.reAgentCodesOptions = this.allAgentCodesOptions;
      this.SalerAreaId = [];
      this.$nextTick(function() {
        self.LoadreSubAgentCodesOptions();
      });
      return true;
    },
    AgentSelect: function(e) {
      var self = this;
      this.$nextTick(function() {
        self.LoadreSubAgentCodesOptions();
      });
    },
    AgentDeselect: function(e) {
      var self = this;
      this.$nextTick(function() {
        self.LoadreSubAgentCodesOptions();
      });
    },
    AgentClear: function(e) {
      var self = this;
      this.$nextTick(function() {
        self.LoadreSubAgentCodesOptions();
      });
      return true;
    },
    LoadreSubAgentCodesOptions: function(e) {
      var self = this;
      console.log('[QIGroupByAgent] LoadreSubAgentCodesOptions called', {
        SalesAreaId: self.reDepartments,
        AgentCodes: self.reAgentCodes
      });
      axios
        .post("/Api/Report/Select2QISubAgent", {
          SalesAreaId: self.reDepartments,
          AgentCodes: self.reAgentCodes,
          page: 1,
          all: true,
        })
        .then(function(response) {
          console.log('[QIGroupByAgent] Select2SubAgent response:', response.status, response.data);
          if (response.status == 200) {
            var data = response.data.results;
            self.reSubAgentCodesOptions = [];
            data.forEach((element) => {
              self.reSubAgentCodesOptions.push({
                id: element.id,
                label: element.text,
              });
            });
            self.allSubAgentCodesOptions = self.reSubAgentCodesOptions;
          }
        })
        .catch(function(error) {
          console.error('[QIGroupByAgent] Select2SubAgent error:', error);
        });
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    },
    // #18: Top scrollbar — inject เหนือ DataTables scroll container
    setupTopScrollbar: function() {
      var scrollBody = document.querySelector('#QIGroupByAgentTable_wrapper .dataTables_scrollBody');
      var scrollHead = document.querySelector('#QIGroupByAgentTable_wrapper .dataTables_scrollHead');
      if (!scrollBody || !scrollHead) return;

      // สร้าง top scrollbar div
      var topScroll = document.createElement('div');
      topScroll.id = 'topScrollbar';
      topScroll.style.cssText = 'overflow-x: auto; overflow-y: hidden; height: 20px; margin-bottom: -1px;';
      var inner = document.createElement('div');
      inner.id = 'topScrollbarInner';
      inner.style.cssText = 'height: 1px;';
      topScroll.appendChild(inner);

      // แทรกเหนือ scrollHead (เหนือ column header)
      scrollHead.parentNode.insertBefore(topScroll, scrollHead);

      // Sync scroll ทั้งสองทาง
      var syncing = false;
      topScroll.addEventListener('scroll', function() {
        if (syncing) { syncing = false; return; }
        syncing = true;
        scrollBody.scrollLeft = topScroll.scrollLeft;
      });
      scrollBody.addEventListener('scroll', function() {
        if (syncing) { syncing = false; return; }
        syncing = true;
        topScroll.scrollLeft = scrollBody.scrollLeft;
      });

      this.syncTopScrollbar();
    },
    syncTopScrollbar: function() {
      this.$nextTick(function() {
        var scrollBody = document.querySelector('#QIGroupByAgentTable_wrapper .dataTables_scrollBody');
        var inner = document.getElementById('topScrollbarInner');
        if (!scrollBody || !inner) return;
        inner.style.width = scrollBody.scrollWidth + 'px';
      });
    }
  },
  async mounted() {
    let self = this;

    self.LoadreDepartmentsOptions();
    self.LoadreAgentCodesOptions();
    self.LoadreSubAgentCodesOptions();
    self.LoadreScoresOptions();
    // self.LoadreUserIdsOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

    // #9: calendar min date = 01/01/<previous year>, apply only for AGENT_REPORT/SUB_AGENT_REPORT
    var isAgentOrSubAgent = !self.$root.canShow(['super_admin']) && self.$root.canShow(['AGENT_REPORT', 'SUB_AGENT_REPORT']);
    var datePickerStartOpts = {
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      endDate: moment().toDate(), // Today
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    };
    if (isAgentOrSubAgent) {
      datePickerStartOpts.startDate = moment().subtract(1, "years").startOf("year").toDate(); // 01/01/<previous year>
    }
    $(self.$refs.reStartDate).datepicker(datePickerStartOpts);
    //self.reStartDate = moment().set("date",1);
    $(self.$refs.reStartDate)
      .datepicker(
        "update",
        !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    var datePickerEndOpts = {
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      endDate: moment().toDate(), // Today
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    };
    if (isAgentOrSubAgent) {
      datePickerEndOpts.startDate = moment().subtract(1, "years").startOf("year").toDate(); // 01/01/<previous year>
    }
    $(self.$refs.reEndDate).datepicker(datePickerEndOpts);
    //self.reEndDate = moment().endOf('month');
    $(self.$refs.reEndDate)
      .datepicker(
        "update",
        !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#QIGroupByAgentTable");
    //begin first table
    table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/QIGroupByAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              StartDate:
                self.reStartDate != null
                  ? self.reStartDate.format("DD/MM/YYYY")
                  : self.reStartDate,
              EndDate:
                self.reEndDate != null
                  ? self.reEndDate.format("DD/MM/YYYY")
                  : self.reEndDate,
              Departments: self.reDepartments,
              AgentCodes: self.reAgentCodes,
              UserIds: self.reUserIds,
              Scores: self.reScores,
              SubAgentCodes: self.reSubAgentCodes,
              IsInitial: self.reIsInitial
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [30, 50, 100],

        pageLength: 30,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        order: [[3, "desc"]],
        columns: [
          {
            data: "createdDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          { data: "agentName", className: "text-center" },
          { data: "subAgentName", className: "text-center" },
          {
            data: "createdDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.createdDateString;
            },
          },
          { data: "userFullName", className: "text-center" },
          { data: "department", className: "text-center" },
          {
            data: "shopTypeCode",
            className: "text-center",
            render: function(data, type, full, meta) {
              return (full.shopTypeCode =="SUB_AGENT") ? "ร้านค้าตัวแทนจำหน่ายย่อย"  : "ร้านค้าตัวแทนจำหน่าย";
            },
          },
          { data: "shopName", className: "text-center" },
          { data: "shopName2", className: "text-center" },
          {
            data: "totalScore",
            className: "text-center",
            render: function(data, type, full, meat) {
              if (full.totalScore == null) {
                return "ไม่มีคะแนนประเมิน";
              } else {
                return full.totalScore;
              }
            },
          },
        ],
        drawCallback: function(settings) {
          self.reIsInitial = false;
          self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
          self.reAverageScore = settings.json ? settings.json.averageScore : null;

          // var allPage = table.DataTable().page.info().pages;
          // var currentPage = table.DataTable().page.info().page +1;

          // self.isShowFooter = false;
          // self.TotalAmount = 0;

          // if(allPage == currentPage){
          //   self.isShowFooter = true;
          //   self.TotalAmount = settings.json.data[0].totalAmount;
          // }
        },
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // #18: Sync top scrollbar width after DataTable redraw
        self.syncTopScrollbar();
      });

    // #18: Setup top scrollbar sync
    this.$nextTick(function() {
      self.setupTopScrollbar();
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/QIGroupByAgent.vue